import React from 'react'
import './SectionThree.css'
function SectionThree() {
    return (
        <div
            className='section-three-body'
        >SectionThree
            <img src='/section-three/main.gif'
                className='third-section-image'
            />
        </div>
    )
}

export default SectionThree